/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GetSerproDataResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'PersonBasicInfo',
      },
    },
  }],
} as const;
